// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1hxtY","label":"Radio_label__23zd5","checkMark":"Radio_checkMark__c06NN","disabled":"Radio_disabled__3w-l_"};